export default __webpack_public_path__ + "f964969107eb255c6cf126173ceedd2d.png";